class RepScrollbar extends HTMLElement {
  constructor() {
    super();
    this.target = document.getElementById(this.dataset.targetId);
  }

  connectedCallback() {
    const stylesheet = new CSSStyleSheet();
    stylesheet.replaceSync(`
      :host .scrollbar-track {
        position: relative;
        width: 100%;
        height: 1px;
        background-color: #D9D9D9;
      }

      :host .scrollbar-thumb {
        position: absolute;
        top: 0;
        left: 0;
        height: 1px;
        background-color: #000000;
      }
    `);

    this.attachShadow({ mode: "open" }).adoptedStyleSheets = [stylesheet];

    this.shadowRoot.innerHTML += `
      <div class="scrollbar-track">
        <div class="scrollbar-thumb"></div>
      </div>
    `;

    this.scrollbarTrackEl = this.shadowRoot.querySelector(".scrollbar-track");
    this.scrollbarThumbEl = this.shadowRoot.querySelector(".scrollbar-thumb");
    this.trackWidth = this.scrollbarTrackEl.getBoundingClientRect().width;

    this.setScrollbarThumbWidth();
    this.attachListeners();

    const observer = new MutationObserver((mutations) => {
      const hasChildBeenAddedOrRemoved = mutations.find(
        (mutation) => mutation.type === "childList"
      );
      if (hasChildBeenAddedOrRemoved) {
        this.setScrollbarThumbWidth();
      }
    });

    observer.observe(this.target, {
      childList: true,
      subtree: true,
    });

    this.target.addEventListener("scroll", () => {
      this.moveScrollbarThumb();
    });
  }

  moveScrollbarThumb() {
    const trackWidth = this.scrollbarTrackEl.getBoundingClientRect().width;
    const thumbWidth =
      (this.target.scrollLeft / this.target.scrollWidth) * trackWidth;
    this.scrollbarThumbEl.style.left = `${thumbWidth}px`;
  }

  setScrollbarThumbWidth() {
    const targetWidth = this.target.getBoundingClientRect().width;
    const scrollThumbWidth = Math.ceil(
      (targetWidth / this.target.scrollWidth) * this.trackWidth
    );
    this.scrollbarThumbEl.style.width = `${scrollThumbWidth}px`;
  }

  attachListeners() {
    // attach click-drag event on the thumb
    let isDragging = false;
    let currentX;
    this.scrollbarThumbEl.addEventListener("mousedown", (e) => {
      isDragging = true;
      currentX = e.clientX;
      this.target.classList.add("prevent-scroll");
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;

      this.scrollbarTrackEl.style.position = "";
      this.scrollbarThumbEl.style.height = "";
      this.scrollbarThumbEl.style.transform = "";
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - currentX;
      currentX = e.clientX;
      this.target.scrollLeft +=
        deltaX * (this.target.scrollWidth / this.trackWidth);
    });

    this.scrollbarThumbEl.addEventListener("mouseenter", () => {
      this.scrollbarTrackEl.style.position = "static";
      this.scrollbarThumbEl.style.height = "5px";
      this.scrollbarThumbEl.style.transform = "translateY(-1.5px)";
    });

    this.scrollbarThumbEl.addEventListener("mouseleave", () => {
      if (isDragging) return;

      this.scrollbarTrackEl.style.position = "";
      this.scrollbarThumbEl.style.height = "";
      this.scrollbarThumbEl.style.transform = "";
    });
  }
}
customElements.define("rep-scrollbar", RepScrollbar);
